var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5871 17.0423L14.8599 3.65825C13.5978 1.44725 10.4061 1.44725 9.14854 3.65825L1.41686 17.0423C0.15473 19.2533 1.72558 22 4.27254 22H19.7041C22.2511 22 23.8492 19.226 22.5871 17.0423ZM11.9997 19.0308C11.3278 19.0308 10.7693 18.4724 10.7693 17.8005C10.7693 17.1285 11.3278 16.5701 11.9997 16.5701C12.6716 16.5701 13.23 17.1285 13.2028 17.8322C13.2346 18.4724 12.6444 19.0308 11.9997 19.0308ZM13.1211 11.0767C13.0666 12.0301 13.0076 12.9789 12.9531 13.9324C12.9259 14.2411 12.9259 14.5226 12.9259 14.8267C12.8986 15.3307 12.5036 15.7211 11.9997 15.7211C11.4957 15.7211 11.1053 15.3579 11.0735 14.854C10.9918 13.3694 10.9055 11.912 10.8238 10.4274C10.7966 10.037 10.7693 9.64202 10.7376 9.25157C10.7376 8.60689 11.1008 8.0757 11.691 7.90772C12.2812 7.76698 12.8668 8.04846 13.1211 8.60689C13.2073 8.80211 13.2346 8.99733 13.2346 9.22433C13.2073 9.84632 13.1483 10.4638 13.1211 11.0767Z",
    fill: "#E6F4FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.dbab4d74fffa2ce7356a43fe47a73edd.svg";
export { ForwardRef as ReactComponent };